export const SampleVehicles = [
    {
        name: "Volkswagen Amarok",
        brand: "Carbucks",
        rego: "ABC123",
        appConsumerId: "4C616251-5F35-4F03-B66C-7C7DC66C84E1",
        appVehicleId: "ABA98A07-A6CA-41BE-A422-55D0412ECC3E",
        appMode: "dark",
        gpsLat: -33.8906921,
        gpsLong: 151.059428,
        nonce: 3368069,
        timestamp: 1708313160266,
        signForUat: "1c4e137721f918f3fa6417df67fd08baef79c43f4e2182daba66293d9afd077e",
        signForDev: "2b1787836ef0493fa3887dda62ac672ffdba753c8827dfc342eb794eb3d81ea6",
        signForLocal: "99fefe51d4403c9df1ea842e9097848e4f0114bb10d5e8eb2ec753a06c6f2943"
    },
    {
        name: "ISUZU S-Series NLS",
        brand: "ISUZU",
        rego: "MARK1",
        appConsumerId: "0FA4FAA0-BF56-4529-A976-24C677B0FFA8",
        appVehicleId: "4D3F6278-549F-45B5-94FE-627F3CFD5DC6",
        appMode: "dark",
        gpsLat: -27.514305649293714,
        gpsLong: 153.00290780770456,
        nonce: 6830363,
        timestamp: 1708305312673,
        signForUat: "beeaaf7fce6a40c8bf41b85f3196cb0085d284358ba90db39bfd3623a8a93456",
        signForDev: "06b061e84e1ea775f58204b6c6ae743dd86ed637613c71308614503e004a5101",
        signForLocal: "f61cf1a59dbc17c33671804d9e32217f210a1320ec08dc31631c874721ca1fd1"
    }
]
